import React, { useContext, useState, useEffect } from 'react';
import { ScrollablePane, Stack } from '@fluentui/react';
import { AppAuthContext } from './contexts/AppAuthContext';
import { AppThemeContext } from './contexts/AppThemeContext';
import NavBar from './components/NavBar';
import Loader from './components/Loader';
import AppRouter from './routers/AppRouter';
import { HashRouter as Router } from 'react-router-dom';

const AppRoot = () => {
    const { initAuth, isAuth } = useContext(AppAuthContext);
    const { theme } = useContext(AppThemeContext);

    const [isLoading, setLoading] = useState(true);

    const myStyles = {
        app: {
            root: {
                height: '100%',
                backgroundColor: theme.semanticColors.bodyBackground,
            }
        },
        appContainer: {
            root: {
                minHeight: '100%',
            }
        },
        scrollablePane: {
            root: {
                flex: 1,
                position: 'relative',
            },
            contentContainer: {
                padding: 5,
                paddingTop: 10,
            }
        }
    };

    useEffect(() => {
        const initialize = async () => {
            if (isAuth === false) {
                await initAuth();
            }

            setLoading(false);
        }

        initialize();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Router>
            <Stack styles={myStyles.app} >
                {isLoading ?
                    <Loader />
                    :
                    <Stack verticalFill>
                        <Stack.Item shrink>
                            <Stack>
                                <NavBar />
                            </Stack>
                        </Stack.Item>
                        <Stack.Item grow>
                            <Stack horizontal styles={myStyles.appContainer}>
                                <Stack.Item grow styles={{ root: { backgroundColor: 'inherit' } }}>
                                    <Stack verticalFill>
                                        <ScrollablePane styles={myStyles.scrollablePane} scrollbarVisibility={"auto"}>
                                            <AppRouter />
                                        </ScrollablePane>
                                    </Stack>
                                </Stack.Item>
                            </Stack>
                        </Stack.Item>
                        {/* <Stack.Item>
                            <Footer />
                        </Stack.Item> */}
                    </Stack>
                }
            </Stack>
        </Router>
    )
}

export default AppRoot;